import { Grid, Checkbox, Tab } from 'semantic-ui-react'
import { connect } from 'react-redux'
import clientActions from '../../store/actions/clients'
import { useTranslation } from 'react-i18next'

const ClientContactGeneralPermissions = ({
	permissions,
	onChange = () => { },
}) => {
	const { t } = useTranslation()
	const toggleCheck = (field) => {
		onChange({ ...permissions, [field]: !permissions[field] })
	}

	return (
		<Tab.Pane attached={false}>
			<Grid>
				<Grid.Row>
					<Grid.Column computer={16}>
						<Checkbox
							label={t('Formularios')}
							checked={permissions?.form_permits}
							onClick={() => toggleCheck('form_permits')}
						/>
					</Grid.Column>
					<Grid.Column computer={16} style={{ marginTop: 10 }}>
						<Checkbox
							label={t('Chat de pasajeros')}
							checked={permissions?.chat_passenger_permits}
							onClick={() => toggleCheck('chat_passenger_permits')}
						/>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</Tab.Pane>
	)
}

const mapDispatchToProps = (dispatch) => ({
	getClientModules: () => dispatch(clientActions.getClientModules()),
})

export default connect(null, mapDispatchToProps)(ClientContactGeneralPermissions)
